"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.padStart = void 0;
function padStart(str, length, character) {
    while (str.length < length) {
        str = character + str;
    }
    return str;
}
exports.padStart = padStart;
//# sourceMappingURL=string.js.map